import React from "react";
import Error from "./common/Error";

const Unauthorized = props => {

    return (
        <Error errorStatus={'401'} errorText={'Unauthorized'} errorDescription={"It looks like you don't have proper permissions to access the resource!"}/>
    );

};

export default Unauthorized;